module.exports = __webpack_public_path__ + "static/img/gjdw.a254e89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/gjdw.png
// module id = Ba8j
// module chunks = 13